import { useState } from 'react';
import styled from 'styled-components';
import { Flex } from '#atoms';
import Day from '../../Day';
import TimePeriod from '../../TimePeriod';
import { useRecoilState } from 'recoil';
import { Day as DayIndex, differentStateAtom } from '../../../Step6.atoms';

type DayScheduleProps = {
  day: string;
  emtpyDescription?: string;
  dayIndex: number;
};

export default function DaySchedule({
  day,
  emtpyDescription = '수업이 없어요',
  dayIndex
}: DayScheduleProps) {
  const [isSelected, setIsSelected] = useState(false);
  const [differentState, setDifferentState] =
    useRecoilState(differentStateAtom);

  const peroids = differentState[dayIndex as DayIndex];

  const handleAddTime = () => {
    setDifferentState(prev => ({
      ...prev,
      [dayIndex]: [
        ...peroids,
        {
          startAt: undefined,
          endAt: undefined
        }
      ]
    }));
  };

  const onChangeStartAt = (index: number) => (date: Date) => {
    setDifferentState(prev => {
      const periods = [...prev[dayIndex as DayIndex]];
      periods[index] = { ...periods[index], startAt: date };
      return { ...prev, [dayIndex]: periods };
    });
  };

  const onChangeEndAt = (index: number) => (date: Date) => {
    setDifferentState(prev => {
      const periods = [...prev[dayIndex as DayIndex]];
      periods[index] = { ...periods[index], endAt: date };
      return { ...prev, [dayIndex]: periods };
    });
  };

  return (
    <Wrapper fullWidth gap={12}>
      <Day
        day={day}
        style={{ width: '44px', height: '44px' }}
        isSelected={isSelected}
        onClick={() => {
          setIsSelected(selected => !selected);
          setDifferentState(prev => ({
            ...prev,
            [dayIndex]: isSelected
              ? [{ startAt: undefined, endAt: undefined }]
              : prev[dayIndex as DayIndex]
          }));
        }}
      />
      <Column>
        {isSelected ? (
          <TimeWrapper gap={8} direction="column">
            <TimePeriod
              startAt={peroids[0]?.startAt}
              endAt={peroids[0]?.endAt}
              onChangeStartAt={onChangeStartAt(0)}
              onChangeEndAt={onChangeEndAt(0)}
            />
            {peroids.map((period, index) => {
              if (index === 0) return null;

              const onRemove = () => {
                setDifferentState(prev => {
                  const periods = [...prev[dayIndex as DayIndex]];
                  periods.splice(index, 1);
                  return { ...prev, [dayIndex]: periods };
                });
              };

              return (
                <TimePeriod
                  key={index}
                  startAt={period.startAt}
                  endAt={period.endAt}
                  onChangeStartAt={onChangeStartAt(index)}
                  onChangeEndAt={onChangeEndAt(index)}
                  onRemove={onRemove}
                  hasDeletedIcon
                />
              );
            })}
            <AddTime onClick={handleAddTime}>+ 시간 추가</AddTime>
          </TimeWrapper>
        ) : (
          <EmptyDescription>
            {day}요일은 {emtpyDescription}
          </EmptyDescription>
        )}
      </Column>
    </Wrapper>
  );
}

const Wrapper = styled(Flex)``;
const Column = styled.div`
  flex: 1;
`;
const EmptyDescription = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.gray800};
  color: ${({ theme }) => theme.palette.gray300};
  padding: 10px 16px;
  border-radius: 8px;
`;
const TimeWrapper = styled(Flex)``;

const AddTime = styled.span`
  margin-right: 8px;
  cursor: pointer;
  align-self: flex-end;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brand300};
  font-weight: 500;
`;
